import { styled } from '@mui/material';
import Badge from '@mui/material/Badge';

export const HBBadgeRootStyle = styled(Badge)((props) => ({})) as typeof Badge;
